import React, { useCallback } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const TELEGRAM_REVIEW_LINK =
  'https://t.me/pmu_support_bot?start=product_review';

const AlreadyRegistered = ({
  setScreenNumber,
  telegramLink,
  handleBackToMenu,
  onTelegramHandleClick
}) => {
  const onTelegramClick = useCallback(() => {
    onTelegramHandleClick();
    window.open(TELEGRAM_REVIEW_LINK, '_blank');
  }, [onTelegramHandleClick]);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
          onTelegramHandleClick={onTelegramHandleClick}
        />
      </div>
      <p className={styles.title}>Супер!</p>
      <p className={styles.description}>
        Бачимо, що ти вже зареєстрований.
        <br />
        Не гай часу, залишай відгук у телеграмі та отримуй винагороду за
        витрачений час.
      </p>
      <div className={styles.notification}>
        <div className={styles.panel} />
        <div className={styles.signal}>
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className={styles.cardBack} />
        <div className={styles.cardMiddle} />
        <div className={styles.cardFront} />
        <div className={styles.cardTop}>
          <div className={styles.avatar}>
            <img
              src="/images/ua-hostess/mr-philip-avatar.png"
              alt="mr-philip-icon"
            />
            <span className={styles.telegramBadge}>
              <img src="/images/ua-hostess/telegram-arrow.svg" alt="" />
            </span>
          </div>
          <p className={styles.sender}>Mr.Philip</p>
          <p className={styles.messagePreview}>Нове повідовлення</p>
        </div>
        <div className={styles.typingBubble}>
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.telegramButton} onClick={onTelegramClick}>
          Доєднатись до Telegram
        </button>
        {handleBackToMenu && (
          <button className={styles.backButton} onClick={handleBackToMenu}>
            Повернутись до меню
          </button>
        )}
      </div>
    </div>
  );
};

export default AlreadyRegistered;
